import React from 'react';
import { motion } from 'framer-motion';
import { useAuthStore } from '../../store/authStore';
import SafeIcon from '../../common/SafeIcon';
import { LOGOS } from '../../assets/logos';
import * as FiIcons from 'react-icons/fi';

const { FiUser, FiLogOut, FiSettings, FiHelpCircle } = FiIcons;

const Header = ({ title = "Dashboard" }) => {
  const { user, logout } = useAuthStore();

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="bg-white border-b border-gray-200 px-6 py-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center space-x-3"
          >
            <img 
              src={LOGOS.FAVICON_BLUE} 
              alt="VIXEA" 
              className="w-8 h-8 object-contain" 
            />
            <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
          </motion.div>
        </div>

        <div className="flex items-center space-x-4">
          <button className="p-2 text-gray-400 hover:text-gray-600 transition-colors">
            <SafeIcon icon={FiHelpCircle} className="w-5 h-5" />
          </button>

          <div className="relative group">
            <button className="flex items-center space-x-3 p-2 rounded-lg hover:bg-gray-100 transition-colors">
              <img 
                src={LOGOS.PROFILE_BLUE} 
                alt="Profile" 
                className="w-8 h-8 rounded-full object-contain" 
              />
              <div className="text-left">
                <p className="text-sm font-medium text-gray-900">{user?.name}</p>
                <p className="text-xs text-gray-500">{user?.email}</p>
              </div>
            </button>

            <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50">
              <div className="py-1">
                <button className="flex items-center space-x-2 px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 w-full text-left">
                  <SafeIcon icon={FiSettings} className="w-4 h-4" />
                  <span>Configuración</span>
                </button>
                <button
                  onClick={handleLogout}
                  className="flex items-center space-x-2 px-4 py-2 text-sm text-red-600 hover:bg-red-50 w-full text-left"
                >
                  <SafeIcon icon={FiLogOut} className="w-4 h-4" />
                  <span>Cerrar sesión</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;